export const GUARDRAILS_SLICE_NAME = 'guardrails';

export const GuardrailName = {
  JAILBREAK_DEFENCE: 1,
  HALLUCINATION_CONTROL: 2,
  AI_IDENTITY: 3,
  EMERGENCY_ESCALATION: 4,
  TOOL_CALL_INTEGRITY: 5,
} as const;

export type GuardrailNameKey = keyof typeof GuardrailName;

export const GUARDRAIL_NAME_BY_VALUE = Object.fromEntries(
  Object.entries(GuardrailName).map(([k, v]) => [v, k]),
) as Record<number, GuardrailNameKey>;

export const GUARDRAIL_NAME_KEYS = Object.keys(
  GuardrailName,
) as GuardrailNameKey[];

export const DEFAULT_GUARDRAILS: Record<
  GuardrailNameKey,
  { enabled: boolean }
> = {
  JAILBREAK_DEFENCE: { enabled: true },
  HALLUCINATION_CONTROL: { enabled: true },
  AI_IDENTITY: { enabled: true },
  EMERGENCY_ESCALATION: { enabled: true },
  TOOL_CALL_INTEGRITY: { enabled: true },
};
